


import { Routes, RouterModule } from '@angular/router';
import { BookmarkComponent } from './bookmark.component';

const routes: Routes = [
    {
        path: '',
        component: BookmarkComponent
    },
];

export const BookmarkRoutes = RouterModule.forChild(routes);
